import React from "react";

export const FaIcon = ({ icon, className = "", onClick, align = "align-middle", title }) => (
  <i className={`fa-fw ${icon} ${align} ${className}`} onClick={onClick} title={title} />
);
